document.addEventListener('click', (e) => {
    if (e.target.closest('.product-cat-filter')) {
        const catFilters = document.querySelectorAll('.product-cat-filter')
        catFilters.forEach((catFilter) => catFilter.classList.remove('active'))

        const catFilter = e.target.closest('.product-cat-filter')
        const filterValue = catFilter.dataset.value
        const postListing = catFilter.closest('.pc-products')
        const postContainer = postListing.querySelector('.product-listing')
        const loadMoreBtn = postListing.querySelector('.load-more')
        if (loadMoreBtn) {
            loadMoreBtnText = loadMoreBtn.querySelector('.load-more-text')
            loadMoreBtn.dataset.catId = filterValue
        }

        postContainer.classList.add('animate-pulse')

        const data = new FormData()
        data.append('action', 'load_more')
        data.append('security', liGlobal.loadMore)

        data.append('cat_id', filterValue)
        data.append('post_type', 'product')

        fetch(liGlobal.ajaxUrl, {
            method: 'POST',
            body: data,
        })
            .then((response) => response.text())
            .then((response) => {
                response = JSON.parse(response)
                if (!response.success) {
                    return
                }

                catFilter.classList.add('active')
                if (loadMoreBtn) {
                    if (response.data.load_more_btn_text === 'No more posts') {
                        loadMoreBtn.setAttribute('disabled', 'disabled')
                        loadMoreBtn.classList.remove('loading')
                    } else {
                        loadMoreBtn.removeAttribute('disabled')
                    }

                    loadMoreBtnText.textContent = response.data.load_more_btn_text
                }

                const posts = response.data.posts
                console.log(posts)

                postContainer.innerHTML = ''
                posts.forEach((post) => {
                    postContainer.insertAdjacentHTML('beforeend', post)
                })
                postContainer.classList.remove('animate-pulse')
            })
            .catch((error) => {
                postContainer.classList.remove('animate-pulse')
                console.error(error)
            })
    }

    if (e.target.closest('.product-by-cat-filter')) {
        const catFilters = document.querySelectorAll('.product-by-cat-filter')
        const categories = document.querySelectorAll('.category')
        const catFilter = e.target.closest('.product-by-cat-filter')

        catFilters.forEach((catFilter) => catFilter.classList.remove('active'))

        categories.forEach((category) => {
            category.classList.remove('show')

            setTimeout(() => {
                category.classList.remove('active')
            }, 500)
        })

        catFilter.classList.add('active')
        categories.forEach((category) => {
            if (category.dataset.category === catFilter.id) {
                setTimeout(() => {
                    category.classList.add('active')
                }, 500)
                setTimeout(() => {
                    category.classList.add('show')
                }, 600)
            } else if (catFilter.id === 'all') {
                setTimeout(() => {
                    category.classList.add('active')
                }, 500)
                setTimeout(() => {
                    category.classList.add('show')
                }, 600)
            }
        })
    }
})
